import { useState, useEffect } from "react";

import { fetchItems } from "../../utils/fetchItemData";
import { useModalStack } from "../../utils/modalContext";

const DiscItems = () => {
  const [discoverabilityItems, setDiscoverabilityItems] = useState([]);
  const { pushModal } = useModalStack();

  const handleOpen = async (item) => {
    try {
      const data = await fetchItems({itemId: item.id});
      if (data?.[0]) {
        pushModal({
          id: `item-${item.id}`,
          type: "itemModal",
          props: {
            item: data[0],
            onClose: () => {},
            showNavigation: false,
            onNavigate: null,
            totalItems: 1,
            index: null,
          },
        });
      }
    } catch (err) {
      console.error("Failed to fetch item:", err);
    }
  };

  const fetchDiscoverabilityItems = async () => {
    try {
      const response = await fetch("https://api.pixelore.wiki/api/discitems");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setDiscoverabilityItems(data);
    } catch (error) {
      console.error("Failed to fetch discoverability items", error);
    }
  };

  useEffect(() => {
    fetchDiscoverabilityItems();
  }, []);

  return (
    <div className="overflow-x-auto">
    <table className="market-table overflow-x-auto">
      <thead>
        <tr>
          <th>Name</th>
          <th>Points</th>
          <th>How To Get</th>
          <th>How Many Exist</th>
          <th>Other</th>
        </tr>
      </thead>
      <tbody>
        {discoverabilityItems.map((item) => (
          <tr key={item.id}>
            <td className="modal-click" onClick={() => handleOpen(item)}>
              <img
                src={item.image?.startsWith("cdn:/") ? item.image.replace("cdn:/", "https://d31ss916pli4td.cloudfront.net/") : item.image}
                alt={item.name}
                className="h-10 w-10 inline"
              />{" "}
              {item.name}
            </td>
            <td>{item.notes[0].discpts}</td>
            <td>{item.notes[0]?.obtain?.join(", ") || ""}</td>
            <td>{item.notes[0].exist}</td>
            <td className="text-pretty">{item.notes[0].description}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
};

export default DiscItems;
